import { dataFetcher } from 'core/services/requestHandler';   

const getDashboardDataList = async (data = {}, config = {}) => {
  return dataFetcher('dashboard/getDashboardDataList', data, {...config});
};

const getDashboardData = async (data = {}, config = {}) => {
  return dataFetcher('dashboard/getDashboardData', data, {...config});
};

const getDashboardBannerData = async (data = {}, config = {}) => {
  return dataFetcher('dashboard/getDashboardBannerData', data, {...config});
};

export { getDashboardDataList, getDashboardData, getDashboardBannerData };
